module.exports = __webpack_public_path__ + "3c7ce603732f35f91fed97454210e9e4.svg";